export default __webpack_public_path__ + "static/media/migration_icon.1abb9ba5.svg";